import { Auth } from '@aws-amplify/auth';
import { createClient } from '../services/client';
import userPreferences from '../graphql/userPreferences';
import { addErrorInDatadogRum } from './utilities';

interface SubmitUserPreferencesParams {
  marketingSubscribed: boolean;
  pltvAnalyticsAgreed: boolean;
  fallbackEmail?: string;
}

const submitUserPreferences = async ({
  marketingSubscribed,
  pltvAnalyticsAgreed,
  fallbackEmail,
}: SubmitUserPreferencesParams): Promise<void> => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const userId = user?.attributes?.sub || user?.username;
    const userEmail = user?.attributes?.email || fallbackEmail;

    if (!userId || !userEmail) return;

    await createClient.mutate({
      mutation: userPreferences,
      variables: {
        input: {
          user_id: userId,
          user_email: userEmail.toLowerCase(),
          preferences: {
            marketing_subscribed: marketingSubscribed,
            pltv_analytics_agreed: pltvAnalyticsAgreed,
          },
        },
      },
    });
  } catch (err) {
    addErrorInDatadogRum(err);
  }
};

export default submitUserPreferences;
